import { COLORS } from 'consts/colors'
import styled, { keyframes } from 'styled-components'
import { DURATIONS, EASING, RADII } from 'styles/consts'
import { boxShadowStyles } from 'styles/mixins'

const menuIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: transparent;
`

export const MenuPanel = styled.div`
  position: fixed;
  z-index: 10001;
  min-width: 200px;
  padding: 8px;
  background: ${COLORS.surface};
  border-radius: ${RADII.card};
  ${boxShadowStyles('shadow2')}
  display: flex;
  flex-direction: column;
  gap: 4px;
  transform-origin: top left;
  animation: ${menuIn} ${DURATIONS.fast} ${EASING.out} both;
`

export const MenuItem = styled.button`
  display: flex;
  gap: 8px;
  width: 100%;
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.textPrimary};
  cursor: pointer;
  transition: background-color ${DURATIONS.fast} ${EASING.out};
  padding: 10px 8px;
  border-radius: ${RADII.item};

  &:hover {
    background: ${COLORS.fill};
  }
`

/** Short horizontal rule, centered in the menu panel */
export const MenuDivider = styled.div`
  align-self: center;
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  background: ${COLORS.borderColor};
`
